import { Request, Response, NextFunction } from 'express';
import { ChatService } from '../services/chat.service';
import Container from 'typedi';

export class ChatController {
    public chatService = Container.get(ChatService);

    public createChat = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { participants } = req.body;
            const createdBy = req.user._id;
            const t = req.t;

            const result = await this.chatService.createChat(participants, createdBy, t);
            res.status(201).json({
                status: 'OK',
                message: t('General.created', { field: t('Chat.chat') }),
                data: result,
            });
        } catch (error) {
            next(error);
        }
    };

    public sendMessage = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const { chatId, content, attachments, receiverId } = req.body;
            const senderId = req.user._id;
            const t = req.t;

            const result = await this.chatService.sendMessage(chatId, senderId, receiverId, content, t, attachments || []);
            res.status(201).json({
                status: 'OK',
                message: t('General.created', { field: t('Message.message') }),
                data: result,
            });
        } catch (error) {
            next(error);
        }
    };



    public getChatHistory = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const chatId = req.params.chatId;
            const userId = req.user._id;
            const page = parseInt(req.query.page as string) || 1;
            const limit = parseInt(req.query.limit as string) || 20;
            const t = req.t;

            const result = await this.chatService.getChatHistory(chatId, userId, page, limit, t);
            res.status(200).json({
                status: 'OK',
                message: t('General.fetched', { field: t('Message.messages') }),
                data: result.formattedMessages,
                total: result.totalCount,
                totalPage: result.totalPage,
                participantStatuses: result.participantStatuses,
                sender: result.sender,
                receiver: result.receiver,
                chatId: result.chatId
            });
        } catch (error) {
            next(error);
        }
    };

    public getAllChats = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const userId = req.user._id;
            const page = parseInt(req.query.page as string) || 1;
            const limit = parseInt(req.query.limit as string) || 20;
            const t = req.t;

            const result = await this.chatService.getAllChats(userId, page, limit, t);
            res.status(200).json({
                status: 'OK',
                message: t('General.get_success', { field: t('Chat.chats') }),
                data: result.formattedChats,
                total: result.totalCount,
                page: result.page,
                totalPage: result.totalPage,
            });
        } catch (error) {
            next(error);
        }
    };
    public getById = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const chatId = req.params.chatId;
            const userId = req.user._id;
            const t = req.t;

            const result = await this.chatService.getChatById(chatId, userId, t);
            res.status(200).json({
                status: 'OK',
                message: t('General.get_success', { field: t('Chat.chat') }),
                data: result,
            });
        } catch (error) {
            next(error);
        }
    };
    public getChatsWithUser = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const targetUserId = req.params.userId;
            const userId = req.user._id;
            const page = parseInt(req.query.page as string) || 1;
            const limit = parseInt(req.query.limit as string) || 20;
            const t = req.t;

            const result = await this.chatService.getChatsWithUser(userId, targetUserId, page, limit, t);
            res.status(200).json({
                status: 'OK',
                message: t('Chat.success_fetch_user_chats'),
                data: result,
            });
        } catch (error) {
            next(error);
        }
    };

    public markMessageAsRead = async (req: Request, res: Response, next: NextFunction) => {
        try {
            const messageId = req.params.messageId;
            const userId = req.user._id;
            const t = req.t;

            const result = await this.chatService.markMessageAsRead(messageId, userId, t);
            res.status(200).json({
                status: 'OK',
                message: t('General.updated', { field: t('Message.message') }),
                data: result,
            });
        } catch (error) {
            next(error);
        }
    };
}